// Class: swf.exporters.swflite.timeline.Frame

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Constructor

var Frame = function() {
}

// Meta

Frame.__name__ = "swf.exporters.swflite.timeline.Frame";
Frame.__isInterface__ = false;
Frame.prototype = {
	
};
Frame.prototype.__class__ = Frame.prototype.constructor = $hxClasses["swf.exporters.swflite.timeline.Frame"] = Frame;

// Init



// Statics




// Export

exports.default = Frame;